import projectUpload from './projectUpload'
import Vue from 'vue'
import App from './App.vue'
import store from './stores/'
import router from './router'
import { message } from '@/utils/resetMessage'

import $http from './api/index' // 导入你的 $http 实例
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 核心样式
import plugin from "./plugins/index"

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$projectUpload = projectUpload
Vue.use(plugin, router)
Vue.prototype.$message = message
Vue.prototype.$http = $http


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
